import React, { useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { mineActions, MineTab } from 'features/feedback/store/mine.slice';
import SubmissionRow from 'features/feedback/mine/SubmissionRow';

const TABS: Array<{ key: MineTab; label: string }> = [
  { key: 'ALL', label: 'Усі' }, { key: 'BUG', label: 'Баги' },
  { key: 'REVIEW', label: 'Відгуки' }, { key: 'IDEA', label: 'Ідеї' },
];

const MySubmissionsPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const { items, tab, loading } = useAppSelector((s) => s.mine);

  useEffect(() => {
    dispatch(mineActions.mineGet(tab));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  return (
    <Box sx={{ maxWidth: 720, mx: 'auto', width: '100%', p: 2 }}>
      <Box sx={{ border: '1px solid #E7E7E7', borderRadius: '18px', p: '26px', background: '#fff' }}>
        <Box sx={{ fontSize: 22, fontWeight: 800, mb: 2 }}>Мої звернення</Box>
        <Box sx={{ display: 'flex', gap: 0.5, mb: 2, background: '#f5f6f8', borderRadius: '999px', p: 0.5, width: 'fit-content' }}>
          {TABS.map((t) => (
            <Box
              key={t.key}
              role="button"
              tabIndex={0}
              onClick={() => dispatch(mineActions.setTab(t.key))}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); dispatch(mineActions.setTab(t.key)); } }}
              sx={{
                px: 2, py: 0.75, borderRadius: '999px', cursor: 'pointer', fontSize: 14, fontWeight: 600,
                background: tab === t.key ? '#fff' : 'transparent',
                color: tab === t.key ? '#3B2C93' : '#7A7F88',
              }}
            >
              {t.label}
            </Box>
          ))}
        </Box>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}><CircularProgress /></Box>
        ) : items.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 60, height: 60, borderRadius: '50%', display: 'grid', placeItems: 'center', background: '#E7E7E7' }}>
              <InboxIcon sx={{ color: '#7A7F88' }} />
            </Box>
            <Box sx={{ fontSize: 18, fontWeight: 700 }}>Тут поки порожньо</Box>
            <Box sx={{ fontSize: 14, color: '#7A7F88' }}>Твої звернення з’являться тут.</Box>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {items.map((item) => (
              <SubmissionRow key={item.id} item={item} onDelete={(id) => dispatch(mineActions.deleteItem(id))} />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MySubmissionsPage;
